// Module
var code = "<div class=\"auth-page\"> <div class=\"wide-container\"> <div class=\"auth-wide-background\"></div> <div class=\"auth-panel\" ng-transclude></div> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Auth/Directives/IrisityBackgroundWrapper/IrisityBackgroundWrapper.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;